// extracted by mini-css-extract-plugin
module.exports = {"header":"i_Er","content":"i_Es","grid":"i_Et","centered":"i_Eu","emptyText":"i_Ev"};